// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 938 ? "blockquote" : chunkId) + "." + {"82":"7139345b17ac7269c4ba","938":"2a8ea7bfca1080f792ba"}[chunkId] + ".js";
};